<template>
  <div class="w-100">
    <v-row>
      <v-col cols="6" class="pr-1">
        <v-select
          v-model="sort.field"
          :items="fields"
          item-title="label"
          item-value="column_name"
          variant="solo"
          density="compact"
          menu-icon="fal
        fa-chevron-down"
          :menu-props="{ class: 'kyano-menu' }"
          hide-details
          clearable
          @update:modelValue="emitSort"
        />
      </v-col>
      <v-col cols="6" class="pl-1">
        <v-btn-toggle
          v-model="sort.direction"
          @update:modelValue="emitSort"
          mandatory
          required
          class="btn-toggle w-100"
        >
          <v-btn class="flex-1" value="asc"> A → Z </v-btn>
          <v-btn class="flex-1" value="desc"> Z → A</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: "SortByComponent",
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
      modelValue: {
        type: Object,
        default: () => ({
          field: null,
          direction: "asc",
        }),
      },
    },
    data() {
      return {
        sort: {
          field: this.modelValue?.field || null,
          direction: this.modelValue?.direction || "asc",
        },
      };
    },
    methods: {
      emitSort() {
        this.$emit("update:modelValue", { ...this.sort });
      },
    },
  };
</script>
